var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFileLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-lock-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M40 20V13.6C40 10.2397 40 8.55953 39.346 7.27606C38.7708 6.14708 37.8529 5.2292 36.7239 4.65396C35.4405 4 33.7603 4 30.4 4H17.6C14.2397 4 12.5595 4 11.2761 4.65396C10.1471 5.2292 9.2292 6.14708 8.65396 7.27606C8 8.55953 8 10.2397 8 13.6V34.4C8 37.7603 8 39.4405 8.65396 40.7239C9.2292 41.8529 10.1471 42.7708 11.2761 43.346C12.5595 44 14.2397 44 17.6 44H21M26 22H16M22 30H16M32 14H16",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    opacity: 0.3,
    d: "M38.5 34V30.5C38.5 28.567 36.933 27 35 27C33.067 27 31.5 28.567 31.5 30.5V34M31.2 42H38.8C39.9201 42 40.4802 42 40.908 41.782C41.2843 41.5903 41.5903 41.2843 41.782 40.908C42 40.4802 42 39.9201 42 38.8V37.2C42 36.0799 42 35.5198 41.782 35.092C41.5903 34.7157 41.2843 34.4097 40.908 34.218C40.4802 34 39.9201 34 38.8 34H31.2C30.0799 34 29.5198 34 29.092 34.218C28.7157 34.4097 28.4097 34.7157 28.218 35.092C28 35.5198 28 36.0799 28 37.2V38.8C28 39.9201 28 40.4802 28.218 40.908C28.4097 41.2843 28.7157 41.5903 29.092 41.782C29.5198 42 30.0799 42 31.2 42Z",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileLock);
export default __webpack_public_path__ + "static/media/ic-file-lock.9d440684c2f1be263acff7bad36bbfa3.svg";
export { ForwardRef as ReactComponent };